import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { NotesInput, SaveFeedstockLoadScheduleRequest, UpdateFSInternalNotesRequest } from '../../../interfaces/feedstocklistmodel';
import { FeedstockService } from '../../../services/feedstockservice';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { DragDropModule } from '@angular/cdk/drag-drop';

@Component({
  selector: 'app-save-internal-notes',
  imports: [CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatDialogModule,
      MatCardModule,
      MatFormFieldModule,
      MatInputModule,
      MatButtonModule,
      MatIconModule,
      DragDropModule
    ],
  templateUrl: './save-internal-notes.component.html',
  styleUrl: './save-internal-notes.component.scss'
})
export class SaveInternalNotesComponent {
  title: string = '';
  notes: string = '';
  
  constructor(public dialogRef: MatDialogRef<SaveInternalNotesComponent>,private fsService: FeedstockService,
    @Inject(MAT_DIALOG_DATA) public data: NotesInput
  ) { 
    this.notes = data.scheduleTypeId == 4 
      ? data.ipData.feedstockLoadSchedule.schedulingNotes 
      : data.ipData.feedstockLoadSchedule.internalNotes;
    this.title = "(" + data.workorderno + ")";
  }

  onClose() {
    this.dialogRef.close();
  }

  onSave() {
    const formData : UpdateFSInternalNotesRequest = {
      id: this.data.ipData.feedstockLoadSchedule.id,
      scheduleType: this.data.scheduleTypeId,
      internalNotes: this.notes
    };
    
    console.log('internal notes Form data to save:', formData);

    this.fsService.updateNotes(formData).subscribe({
      next: (response) => {
        console.log('Save successful:', response);
        this.dialogRef.close(this.notes);
      }
    });
  }
}
